
export default class FundPaymentRequestModel {
    public paymentDate?: Date;
    public paymentAmount: number = 0;
    public paymentDescription: string = '';
    public checkNumber: string = '';
}
